var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:['rai-data', 'text-end', _vm.addClass]},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }